// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ahbm","notes":"Notes_notes__1WQzD","note":"Notes_note__11coz","markdown":"Notes_markdown__3DvGc"};